import { useLang } from "@/i18n/LanguageContext";

export default function SupportedLabs() {
  const { t } = useLang();
  const items = t.labs.names;
  const loop = [...items, ...items];

  return (
    <section
      id="labs"
      data-testid="supported-labs"
      className="scroll-mt-28 py-20 md:py-24"
    >
      <div className="container-x flex flex-col items-start gap-8 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="overline" data-testid="labs-overline">{t.labs.overline}</span>
          <h2 className="mt-3 text-3xl text-zinc-900 md:text-4xl">{t.labs.title}</h2>
        </div>
        <p className="max-w-md text-sm text-zinc-500">{t.labs.sub}</p>
      </div>

      <div className="relative mt-12 overflow-hidden border-y border-zinc-200 bg-white py-7">
        <div className="flex w-max animate-marquee items-center gap-12 px-6">
          {loop.map((name, i) => {
            const isSoon = i % items.length >= 3;
            return (
              <span
                key={i}
                className={`flex items-center gap-3 whitespace-nowrap text-sm font-medium ${
                  isSoon ? "text-zinc-400" : "text-zinc-600"
                }`}
                data-testid={`lab-item-${i}`}
              >
                <span
                  className={`h-1.5 w-1.5 rounded-full ${
                    isSoon ? "bg-zinc-300" : "bg-[color:var(--sentinel)]"
                  }`}
                />
                {name}
                {isSoon && (
                  <span className="rounded-full bg-zinc-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
                    {t.labs.soon}
                  </span>
                )}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
}
